@if (categoryPageData$ | async; as model) {
  <ng-container class="cx-page">
    @if (model?.['subCategories']) {
      <!-- category Page -->
      @if (model?.['subCategories'].length!=0) {
        <section tabindex="-1" class="cx-page-section clp"
          [attr.aria-label]="'productList.productListResults' | cxTranslate">
          <div class="container CategoryPage">
            <div class="row">
              @if (model?.['paragraphContent']) {
                <div class="CatogeryText">{{model?.['paragraphContent']}}</div>
              }
              @if (categoryCode == 'NA-000-006-002-003') {
                <div class="CatogeryText compressorUI">
                  <cx-page-slot position="BaSeriesComparisionSlot1"></cx-page-slot>
                  <cx-page-slot position="OilPassingBannerSlot"></cx-page-slot>
                  <cx-page-slot position="BaSeriesComparisionSlot2"></cx-page-slot>
                  <cx-page-slot position="HdepClearanceBannerSlot"></cx-page-slot>
                  <cx-page-slot position="BaSeriesComparisionSlot3"></cx-page-slot>
                </div>
              }
              @for (product of model?.['subCategories']; track product) {
                <app-category-grid-item [product]="product"
                  class="clp-outer outer">
                </app-category-grid-item>
              }
            </div>
          </div>
        </section>
      }
    } @else {
      @if (model.productsCounts != 0) {
        <section tabindex="-1" class="cx-page-section">
          <div class="container">
            <div class="row">
              @if (viewMode$ | async; as viewMode) {
                <div class="col-12 col-lg-12">
                  <div class="cx-sorting top">
                    <div class="row action-row sorting-block">
                      <label class="col-lg-3 total-result">{{ model.productsCounts }} {{ 'common.search_page_totalResults' |
                      cxTranslate }}</label>
                      <label class="col-lg-3 pagination">{{ 'common.pagination_view' | cxTranslate }}
                        <a class="page-size" [routerLink]="" (click)="changePageSize(30, model)"> &nbsp;30&nbsp; </a>
                        {{ 'common.pagination_or' | cxTranslate }}
                        <a class="page-size" [routerLink]="" (click)="changePageSize(90, model)"> &nbsp;90&nbsp; </a>
                      {{ 'common.pagination_items' | cxTranslate }}</label>
                      <label class="sort-by col-lg-1">
                        <span>{{ 'common.search_page_sortTitle' | cxTranslate }}</span>
                      </label>
                      <div class="col-lg-3 sorting">
                        <cx-sorting [sortOptions]="model.sorts" (sortListEvent)="sortListClp($event, model)"
                          [selectedOption]="model.pagination?.sort" [ariaLabel]="'productList.sortResults' | cxTranslate"
                          ariaControls="product-results-list" placeholder="{{ 'productList.sortBy' | cxTranslate }}">
                        </cx-sorting>
                      </div>
                      <div class="col-lg-1 no-padding mode-change d-sm-none d-lg-flex justify-content-end product-view-btn">
                        <cx-product-view (modeChange)="setViewMode($event)" [mode]="viewMode"></cx-product-view>
                      </div>
                    </div>
                  </div>
                  <div id="product-results-list" class="cx-product-container">
                    <!-- Product list when using pagination -->
                    @if (!isInfiniteScroll) {
                      @if (viewMode === ViewModes.Grid || isMobile) {
                        <div class="row">
                          @for (product of model?.products; track product) {
                            <app-kb-product-grid-item [product]="product"
                            class="col-12 col-sm-12 col-md-12 col-lg-3 sm-view product-grid-item"></app-kb-product-grid-item>
                          }
                        </div>
                      }
                      @if (viewMode === ViewModes.List && !isMobile) {
                        @for (product of model?.products; track product) {
                          <app-kb-product-list-item [product]="product"
                          class="cx-product-search-list"></app-kb-product-list-item>
                        }
                      }
                    } @else {
                      <cx-product-scroll [scrollConfig]="scrollConfig" [model]="model"
                      [inputViewMode]="viewMode"></cx-product-scroll>
                    }
                    <!-- Product list when using infinite scroll -->
                  </div>
                  <div class="cx-sorting bottom">
                    <div class="row col-md-12">
                      <label class="col-md-5">{{ 'common.search_page_showing_text' | cxTranslate }}
                        {{ model.pagination.pageSize * model.pagination.currentPage + 1 }}-
                        @if (
                          model.pagination.pageSize * (model.pagination.currentPage + 1) < model.pagination.totalResults
                          ) {
                          <span>{{ model.pagination.pageSize * (model.pagination.currentPage + 1) }}</span>
                        }
                        @if (
                          model.pagination.pageSize * (model.pagination.currentPage + 1) > model.pagination.totalResults
                          ) {
                          <span>{{ model.pagination.totalResults }}</span>
                        }
                        {{ 'common.search_page_of_text' | cxTranslate }} {{ model.pagination.totalResults }}
                      {{ 'common.search_page_result_text' | cxTranslate }}</label>
                      @if (!isInfiniteScroll) {
                        <div class="col-auto col-md-7 d-flex justify-content-end align-items-center">
                          <div class="kb-pagination">
                            <kb-pagination [pagination]="model.pagination" [defaultPage]="0"
                            (viewPageEvent)="changePageCustom($event, model)"></kb-pagination>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </section>
      }
      @if (model.productsCounts == 0) {
        <section class="noResultsFound">
          <p>0 {{ 'common.search_page_totalResults' | cxTranslate }}</p>
        </section>
      }
    }
    <!--  PLP page -->
  </ng-container>
}